import * as React from 'react';

const Declarations = () => (
  <div>
    Lorem ipseum delarations etc
  </div>
)

export default Declarations;